import { useState } from "react";
import { Button, Typography } from "@mui/material";

import { ShieldPlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useResetPasswordUserResetPasswordPostMutation } from "api";
import { SectionCard } from "components/SectionCard/SectionCard";
import { TWO_FACTOR_AUTH } from "constants/auth.constants";
import { getAuthBaseUrl } from "utils/auth.util";
import * as LOCAL_STORAGE from "utils/localStorage";

export function UserAuth() {
  const { t } = useTranslation();

  const [showPasswordResetText, setShowPasswordResetText] =
    useState<boolean>(false);

  const [resetPassword] = useResetPasswordUserResetPasswordPostMutation();

  const changePassword = async () => {
    await resetPassword();
    setShowPasswordResetText(true);
  };

  const handleTwoFactorAuth = () => {
    const client_id = LOCAL_STORAGE.getClientId();

    const url = `${getAuthBaseUrl()}${TWO_FACTOR_AUTH}/?client_id=${client_id}`;
    globalThis.open(url, "_self");
  };

  return (
    <SectionCard title={t("Access")}>
      <Button onClick={() => changePassword()}>{t("Change Password")}</Button>
      {showPasswordResetText && (
        <Typography>
          {t("you_will_recieve_an_email_to_reset_your_password")}
        </Typography>
      )}
      <Typography>{t("multi_factor_authentication_mfa")}</Typography>
      <Button
        startIcon={<ShieldPlusIcon />}
        onClick={() => handleTwoFactorAuth()}
      >
        {t("manage_mfa")}
      </Button>
    </SectionCard>
  );
}
